import React from "react";
import { Routes, Route } from "react-router-dom";
import enteRoutes from "./routers"

import {
    Button,
    Spinner,
    Row,
    Col,
    Icon,
    UncontrolledTooltip,
  } from "design-react-kit";
import CustomHeader from "../../layout/components/CustomHeader";
import CustomSidebar from "../../layout/components/sidebar/CustomSidebar";
import PopUp from "../../common/components/popup/components/PopUp";

const EnteLayout = (props) => {

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            return (
                <Route
                    path={prop.path}
                    element={<prop.component {...props} />}
                    key={key}
                />
            )

        })
    }

    return (
        <>
        <CustomHeader></CustomHeader>
        <div style={{display:"flex", alignItems: "flex-start"}}>
            <PopUp />
            <CustomSidebar routes={enteRoutes} />
            <Routes>
                {
                    getRoutes(enteRoutes)
                }
            </Routes>
        </div>
        </>
        

    )
}

export default EnteLayout